var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","fixed":"","dark":""}},[_c('div',{staticClass:"ml-4"},[_vm._v("© "+_vm._s(_vm.currentYear)+" "),_c('b',[_vm._v(_vm._s(_vm.copyright))])])])}
var staticRenderFns = []

export { render, staticRenderFns }